import {
    Button, FormControl,
    InputAdornment, InputLabel,
    Modal,
    OutlinedInput,
    TextField,
    Typography
} from "@mui/material";
import {TimeManager} from "../../timemanager";
import useToken from "../../useToken";
import {useState} from "react";
import LabelListing from "./LabelListing";
import {OverlayScrollbarsComponent} from "overlayscrollbars-react";

export default function LabelsMenu(props) {
    const {
        open,
        onClose,
        labels,
        refreshLabels,
        mobile
    } = props;

    const [token] = useToken();

    const [editMenuOpen, setEditMenuOpen] = useState(false);
    const [labelKey, setLabelKey] = useState(undefined);
    const [labelName, setLabelName] = useState('');
    const [labelColor, setLabelColor] = useState('');
    const [labelDescription, setLabelDescription] = useState('');

    const beginEdit = (label) => {
        return () => {
            setLabelKey(label.key);
            setLabelName(label.name);
            setLabelColor(label.color.substring(0, 7));
            setLabelDescription(label.description);

            setEditMenuOpen(true);
        };
    };

    const beginCreate = () => {
        setLabelKey(undefined);
        setLabelName('');
        setLabelColor('#1986b0');
        setLabelDescription('');

        setEditMenuOpen(true);
    };

    const finishEdit = () => {
        TimeManager.time.label.alter({
            key: labelKey,
            name: labelName,
            color: labelColor.substring(0, 7).toUpperCase() + 'FF',
            description: labelDescription,
        }, token).then(() => refreshLabels());

        setEditMenuOpen(false);
    };

    const remove = () => {
       TimeManager.time.label.alter({
           key: labelKey,
           delete: true,
       }, token).then(() => refreshLabels());

       setEditMenuOpen(false);
    };

    return (
       <>
           <Modal
               open={open}
               onClose={onClose}
           >
               <div>
                   <OverlayScrollbarsComponent
                       options={{
                           scrollbars: {
                               theme: 'os-theme-light'
                           }
                       }}
                       style={{
                           padding: '4rem',
                           position: 'absolute',
                           top: mobile ? '0' : '50%',
                           left: mobile ? '0' : '50%',
                           transform: !mobile && 'translate(-50%, -50%)',
                           width: mobile ? '100vw' : '700px',
                           maxHeight: mobile ? '100vh' : 'calc(100% - 100px)',
                           height: mobile && '100vh',
                           bgcolor: 'background.paper',
                           boxShadow: '24rem',
                           borderRadius: '5px',
                           overflowY: 'hidden',
                           background: 'rgb(18, 18, 18)',
                       }}
                   >
                       <Typography
                           variant="h1"
                           component="h1"
                           mb="30px"
                           fontSize="18pt"
                           fontWeight="400"
                       >
                           Labels
                       </Typography>

                       {labels.map((label) => (
                           <LabelListing
                               key={label.key}
                               label={label}
                               beginEdit={beginEdit(label)}
                           />
                       ))}

                       <Button
                           variant="contained"
                           sx={{
                               mr: '10px',
                               mt: '30px',
                           }}
                           onClick={beginCreate}
                       >
                           New Label
                       </Button>

                       <Button
                           onClick={onClose}
                           sx={{
                               mt: '30px',
                           }}
                       >
                           Close
                       </Button>

                       <Modal
                           open={editMenuOpen}
                           onClose={() => setEditMenuOpen(false)}
                       >
                           <div>
                               <OverlayScrollbarsComponent
                                   options={{
                                       scrollbars: {
                                           theme: 'os-theme-light'
                                       }
                                   }}
                                   style={{
                                       padding: '4rem',
                                       position: 'absolute',
                                       top: mobile ? '0' : '50%',
                                       left: mobile ? '0' : '50%',
                                       transform: !mobile && 'translate(-50%, -50%)',
                                       width: mobile ? '100vw' : '700px',
                                       maxHeight: mobile ? '100vh' : 'calc(100% - 100px)',
                                       height: mobile && '100vh',
                                       bgcolor: 'background.paper',
                                       boxShadow: '24rem',
                                       borderRadius: '5px',
                                       overflowY: 'hidden',
                                       background: 'rgb(18, 18, 18)',
                                   }}
                               >
                                   <Typography
                                       variant="h1"
                                       component="h1"
                                       mb="30px"
                                       fontSize="18pt"
                                       fontWeight="400"
                                   >
                                       {labelKey ? 'Edit' : 'Create'} Label
                                   </Typography>

                                   <TextField
                                       label="Name"
                                       variant="outlined"
                                       value={labelName}
                                       onChange={(e) => setLabelName(e.target.value)}
                                       sx={{
                                           mb: '20px',
                                       }}
                                       fullWidth
                                   />

                                   <FormControl
                                       variant="outlined"
                                       sx={{
                                           mb: '20px',
                                       }}
                                       fullWidth
                                   >
                                       <InputLabel>Color</InputLabel>
                                       <OutlinedInput
                                           label="Color"
                                           value={labelColor}
                                           onChange={(e) => setLabelColor(e.target.value.substring(0, 7))}
                                           endAdornment={
                                               <InputAdornment position="end">
                                                   <input
                                                       type="color"
                                                       value={labelColor}
                                                       onChange={(e) => setLabelColor((e.target.value).toUpperCase())}
                                                   />
                                               </InputAdornment>
                                           }
                                       />
                                   </FormControl>

                                   <TextField
                                       label="Description"
                                       variant="outlined"
                                       value={labelDescription}
                                       onChange={(e) => setLabelDescription(e.target.value)}
                                       sx={{
                                           mb: '20px',
                                       }}
                                       fullWidth
                                   />


                                   <Button
                                       variant="contained"
                                       sx={{
                                           mr: '10px',
                                           mt: '30px',
                                       }}
                                       onClick={finishEdit}
                                   >
                                       Finish
                                   </Button>

                                   <Button
                                       color="error"
                                       sx={{
                                           mr: '10px',
                                           mt: '30px',
                                       }}
                                       onClick={remove}
                                   >
                                       Delete
                                   </Button>

                                   <Button
                                       onClick={() => setEditMenuOpen(false)}
                                       sx={{
                                           mt: '30px',
                                       }}
                                   >
                                       Cancel
                                   </Button>
                               </OverlayScrollbarsComponent>
                           </div>
                       </Modal>
                   </OverlayScrollbarsComponent>
               </div>
           </Modal>
       </>
    );
}